#import "../fragments/list-bulk-actions-fragment.graphql"

query GetListExports($userId: ID) {
    listBulkActions(userId: $userId) {
        ...ListBulkActionsFragment
    }
}
